import React, { useEffect, useState } from "react";
import moment from "moment";
import store from "../../store/Store";
import UploadTractorEtaData from "../common/upload-new-data/UploadTractorEtaData";
import TractorEtaDataTable from "../common/tables/TractorEtaDataTable";
import { exportData } from "../../utils/helpers";

import { GetETATractor_Aryabhatta } from "../../services/tractorEtaDataService";
import { filter } from "lodash";
import noDataAvailable from "../../assets/img/noDataAvailable.png";
import { dispatcher } from "../../store/storeHelpers";
import * as actionTypes from "../../store/ActionTypes";
import Counters from "../common/Counters";
import { PulseLoader } from "react-spinners";
import TractorETAUploadPlan from "../../assets/ExcelData/TractorETAUploadPlan.json"

function TractorEtaData() {
  const [loader, setLoader] = useState(false);
  const [data, setData] = useState([]);
  const [date, setDate] = useState({
    fromdate:moment().format("YYYY-MM-DD"),
    todate:moment().format("YYYY-MM-DD"),
  });
  const [showDailyPlanUploader, setShowDailyPlanUploader] = useState(false);
  const [userData, setUserData] = useState([])
  const [filteredUserAccessData, setFilteredUserAccessData] = useState([])
  // const [copyData, setCopyData] = useState([])
  const [noDataState, setNoDataState] = useState(false)
  const [carrierList, setCarrierList] = useState({})

	useEffect(() => {
		const unsubscribe = store.subscribe(() => {
			setData(Object.values(store.getState().tractor_ETA));
			setUserData(Object.values(store.getState().userAccessData));
		});
		return () => {
			unsubscribe();
		};
	});

	useEffect(() => {
		setUserData(Object.values(store.getState().userAccessData));
	}, [setUserData]);

	useEffect(() => {
		if (filter(userData, { MenuName: "Tractor ETA", View: 1 }).length > 0) {
			setFilteredUserAccessData(
				filter(userData, { MenuName: "Tractor ETA", View: 1 })
			);
		}
	}, [userData]);
	//  useEffect(()=>{
	//   if(copyData.length > 0){
	//     setData(copyData)
	//   }
	//  },[copyData])
	const resetStorage = () => {
		setData([]);
	};

	useEffect(() => {
		async function getPlan() {
			resetStorage();
			setLoader(true);
			try {
				setNoDataState(false);
				const response = await GetETATractor_Aryabhatta(date);
				dispatcher(actionTypes.TRACTOR_ETA_DATA_LOADING, response);
				// setData(response);
				setLoader(false);
			} catch (error) {
				setLoader(false);
				if (error.response.data.StatusCode === 404) {
					setNoDataState(true);
				}
			}
		}
		getPlan();
	}, [date]);


	const dataExportHandler = () => {
		exportData(
			data.map((item) => {
				return {
					Actual_Pickup_date_from_factory : item["Actual_Pickup_date_from_factory"] === "Invalid date" ? "" : item["Actual_Pickup_date_from_factory"],
				    SAP_Sales_Order_No: item["SAP_Sales_Order_No"],
					Comar_Order_No: item["Comar_Order_No"],
					PY_VY_Invoice_No: item["PY_VY_Invoice_No"],
					Internal_Reference_No: item["Internal_Reference_No"],
					Container_No: item["Container_No"],
					BillType: item["BillType"],
					Serial_Number_of_Product: item["Serial_Number_of_Product"],
					Material_Service_Code: item["Material_Service_Code"],
					Billqty: item["Billqty"],
					Dest_Country: item["Dest_Country"],
					Destination_Port: item["Destination_Port"],
					Carrier: item["Carrier"],
					Count: item["Count" ],
					Engine_No:item["Engine_No"],
					
				
				};
			}),
			`Tractor ETA Data Plan ${moment(date).format("DD-MM-YYYY")}`
		);
	};

	const tractorETATemplateDownloader = () => {
		exportData(
			TractorETAUploadPlan,
			`Tractor ETA Excel Template ${moment(date).format("DD-MM-YYYY")}`
		);
	};

	return (
		<>
			<div className="flex-row mb-12 counterHeaderResponsive">
				<h1>Tractor ETA</h1>
				<Counters
					counter={carrierList}
					label={Object.keys(carrierList)}
					styleData="df_transporterCounter"
				/>
			</div>
			{/* <CreateNewSchedule
				show={showCreateNewSchedule}
				handleClose={() => setShowCreateNewSchedule(false)}
			/> */}
			<UploadTractorEtaData
				show={showDailyPlanUploader}
				handleClose={() => setShowDailyPlanUploader(false)}
				setData={setData}
				setNoDataState={setNoDataState}
				date={date}
				setCarrierList={setCarrierList}
			/>

			{loader && (
				<PulseLoader
					color="#007bff"
					size="20px"
					margin="10px"
					style={{ position: "absolute", top: "50vh", left: "45%" }}
				/>
			)}
			{!loader && noDataState && (
				<img
					src={noDataAvailable}
					alt="notAvailableImg"
					className="noDataFoundImg"
					// style={{marginLeft:"-2%"}}
				/>
			)}
			{!loader && (
				<TractorEtaDataTable
					tableData={data}
					date={date}
					setDate={setDate}
					setShowDailyPlanUploader={setShowDailyPlanUploader}
					dataExportHandler={dataExportHandler}
					subModule="Daily"
					type={"Daily"}
					filteredUserAccessData={filteredUserAccessData}
					noDataState={noDataState}
					setNoDataState={setNoDataState}
					setCarrierList={setCarrierList}
					tractorETATemplateDownloader={tractorETATemplateDownloader}
				/>
			)}
		</>
	);
}

export default TractorEtaData;
